import { render } from "./RegisterAppointment.vue?vue&type=template&id=52c81cde&scoped=true"
import script from "./RegisterAppointment.vue?vue&type=script&lang=js"
export * from "./RegisterAppointment.vue?vue&type=script&lang=js"

import "./RegisterAppointment.vue?vue&type=style&index=0&id=52c81cde&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c81cde"]])

export default __exports__